import { Link } from "react-router-dom";

interface ArticleCardProps {
  slug: string;
  title: string;
  summary: string;
  coverImage: string;
  category: string;
  categoryName: string;
  date: string;
  views: number;
}

export default function ArticleCard({
  slug,
  title,
  summary,
  coverImage,
  category,
  categoryName,
  date,
  views,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/60 overflow-hidden hover:border-rose-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={coverImage}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 bg-rose-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
            {categoryName}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-rose-500 transition-colors">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
          {summary}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span>{date}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {views > 10000 ? `${(views / 10000).toFixed(1)}万` : views}
          </span>
        </div>
      </div>
    </Link>
  );
}